import axios from "axios";

export const fetchDataFromTelligent = async (
  skuCodes: string,
  telligentApiEndpoint: string | undefined
): Promise<any> => {
  if (skuCodes && telligentApiEndpoint) {
    try {
      const response = await axios({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: telligentApiEndpoint,
        data: { pguids: skuCodes },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching data from Telligent:", error);
      throw error;
    }
  }
  throw new Error("Invalid parameters");
};

export default fetchDataFromTelligent;
